<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="dedication">
<header>
<h1 class="topictitle1" id="de1"><a href="#/nav#nde1"><span class="title">Dedication</span></a></h1>
</header>
<div class="dedication_group">
<p class="dedication">For Jim M.</p>
<p class="dedication">What you said was so inspiring!</p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?37cf089e